import { createSelector, createFeatureSelector } from '@ngrx/store';
import { StoreConstants } from 'src/app/shared/models/store.model';
import { IncomingTopicsState } from './reducer';
import * as IncomingTopicsReducer from './reducer';

export const getIncomingTopicsState = createFeatureSelector<IncomingTopicsState>(StoreConstants.FEATURE_STORE_INCOMING_TOPICS);

const pageResultState = createSelector(getIncomingTopicsState, IncomingTopicsReducer.pageResult);

export const getPageResult = (viewId: string) =>
  createSelector(pageResultState, (pageResult: Map<string, IncomingTopicsReducer.IncomingTopicsPageResult>) => {
    if (!pageResult || !pageResult[viewId]) {
      return null;
    }

    return pageResult[viewId];
  });

const pageLoadingState = createSelector(getIncomingTopicsState, IncomingTopicsReducer.pageLoading);

export const getPageLoading = (viewId: string) =>
  createSelector(pageLoadingState, (loadingState: Map<string, boolean>) => {
    if (!loadingState || !loadingState[viewId]) return false;

    return loadingState[viewId];
  });

export const getPageTotalCount = createSelector(getPageResult, (res: any) => (res?.totalCount ? res?.totalCount : 0));

export const getDetailsResult = createSelector(getIncomingTopicsState, IncomingTopicsReducer.detailsResult);

export const getDetailsLoadedAt = createSelector(getIncomingTopicsState, IncomingTopicsReducer.detailsLoadedAt);

export const getDetailsLoading = createSelector(getIncomingTopicsState, IncomingTopicsReducer.detailsLoading);
